import { render, staticRenderFns } from "./SpoiledNewButton.vue?vue&type=template&id=6b3b8e82&scoped=true&"
import script from "./SpoiledNewButton.vue?vue&type=script&lang=js&"
export * from "./SpoiledNewButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3b8e82",
  null
  
)

export default component.exports